import React, { useState } from 'react';
import { 
  QuestionMarkCircleIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from '@heroicons/react/24/outline';
import SectionTitle from './text_components/SectionTitle';


const FrequentlyAskedQuestions = () => {
  const [openQuestions, setOpenQuestions] = useState([]);

  const faqData = [
    {
      question: "How do I start contributing to my 401k?",
      answer: "To start contributing to your 401k, contact your employer's HR department or benefits administrator. They will provide you with the necessary forms and information to enroll in the plan and set up your contributions."
    },
    {
      question: "What is the maximum amount I can contribute to my 401k?",
      answer: "For 2023, the maximum annual contribution limit for a 401k is $22,500 for individuals under 50 years old. If you're 50 or older, you can make an additional catch-up contribution of $7,500, bringing your total to $30,000."
    },
    {
      question: "How do I choose my 401k investments?",
      answer: "Your 401k plan will offer a selection of investment options. Consider factors such as your risk tolerance, age, and retirement goals when choosing investments. Many plans offer target-date funds, which automatically adjust your asset allocation as you approach retirement."
    },
    {
      question: "Can I withdraw money from my 401k before retirement?",
      answer: "While it's generally not recommended, you can withdraw money from your 401k before retirement in certain circumstances. However, early withdrawals may be subject to income tax and a 10% penalty if you're under 59½ years old, unless you qualify for an exception."
    },
    {
      question: "What happens to my 401k if I change jobs?",
      answer: "When you change jobs, you typically have several options for your 401k: you can leave it with your former employer (if allowed), roll it over to your new employer's plan, roll it over to an IRA, or cash it out (not recommended due to taxes and penalties)."
    },
  ];

  const toggleQuestion = (index) => {
    if (openQuestions.includes(index)) {
      setOpenQuestions(openQuestions.filter(i => i !== index));
    } else {
      setOpenQuestions([...openQuestions, index]);
    }
  };

  return (
    <div className="max-w-7xl mx-auto p-8 bg-white rounded-3xl shadow-2xl font-sans mt-10 mb-10 border border-gray-200">
      <SectionTitle>Frequently Asked Questions</SectionTitle>
      
      <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-200 mb-8">
        <h3 className="text-xl font-bold mb-6 text-gray-800 flex items-center">
          <QuestionMarkCircleIcon className="h-6 w-6 mr-2 text-blue-600" />
          Common 401k Questions
        </h3>
        <div className="space-y-4">
          {faqData.map((faq, index) => (
            <div key={index} className="border-b border-gray-200 pb-4">
              <button
                onClick={() => toggleQuestion(index)}
                className="flex justify-between items-center w-full text-left font-semibold text-gray-700 hover:text-blue-600 focus:outline-none transition duration-200"
              >
                <span>{faq.question}</span>
                {openQuestions.includes(index) ? (
                  <ChevronUpIcon className="h-5 w-5 text-blue-600" />
                ) : (
                  <ChevronDownIcon className="h-5 w-5 text-gray-400" />
                )}
              </button>
              {openQuestions.includes(index) && (
                <div className="mt-2 text-gray-600">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      
      <div className="bg-blue-50 p-6 rounded-2xl shadow-lg border border-blue-200">
        <h3 className="text-lg font-semibold mb-4 text-gray-800">
          Still have questions?
        </h3>
        <p className="text-blue-700 mb-4">
          If you couldn't find the answer you were looking for, please don't hesitate to reach out to our support team.
        </p>
        <div className="flex space-x-4">
          <a 
            href="/help"
            className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-200"
          >
            Visit Help Center
          </a>
          <a 
            href="mailto:info@401k-pro.ai"
            className="inline-flex items-center px-4 py-2 bg-white text-blue-600 rounded-lg hover:bg-gray-100 transition duration-200 border border-blue-600"
          >
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default FrequentlyAskedQuestions;